




import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  constructor() {
    super();
    if (document.location.port) {
      return;
    }
    document.location.replace('https://geek.163.com');
  }
}
